export default "__VITE_ASSET__11f54bf4__"